import React from 'react';
import ClinicalNoteSection from '../../../../global/component/ClinicalNote/ClinicalNoteSection';
import { ClinicalNoteType } from '../../../../global/entities/ClinicalNote/ClinicalNote';

interface MedicalHistorySectionProps {
    patientId?: string | number;
    patientName?: string | null;
    patientDateOfBirth?: string | null;
}

const MedicalHistorySection: React.FC<MedicalHistorySectionProps> = (props) => (
    <ClinicalNoteSection
        config={{
            noteType: ClinicalNoteType.MedicalHistory,
            i18nPrefix: 'medicalHistory',
            editRouteSegment: 'medicalHistory',
            showSendToAssistant: true,
        }}
        {...props}
    />
);

export default MedicalHistorySection;
